import { BaseSanitizer } from './BaseSanitizer';
export class EmailSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'EMAIL', 'emails', enabled);
    }
    detectMatches(text) {
        const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
        const matches = [];
        let match;
        while ((match = emailRegex.exec(text)) !== null) {
            matches.push({
                originalText: match[0],
                tag: '',
                startIndex: match.index,
                endIndex: match.index + match[0].length
            });
        }
        return matches;
    }
}
